export default class GetNovedades {
  #repository

  constructor(repository) {
    this.#repository = repository
  }

  async execute() {
    const novedades = await this.#repository.getAll()

    return novedades.map((item) => ({
      id: item.IdNovedad,
      fk_idCatTipoNovedad: item.fk_idTipoNovedad,
      fk_idUsuario: item.fk_idPersonal,
      usuario: item.CUIP,
      descripcion: item.DetalleNovedad,
      fecha: item.fecha,
    }))
  }
}
